<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card  title="Template">
        <template slot="actions">
        </template>
           <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <form id="template-view" @submit.prevent="handleSubmit(onClickCreateTemplate)" autocomplete="off">

    <!-- Name -->
            <div class="mb-3 vx-row">
            <div class="vx-col md:w-1/3 md:mb-0">
                <vs-input
                v-model="form.name"
                label="Name"
                class="w-full"
                placeholder="Enter template name"
                />
            </div>
            <div class="vx-col md:w-1/6 md:mb-0">
                <vs-input
                v-model="form.status"
                label="Status"
                class="w-full"
                :readonly="true"
                />
            </div>
            </div>
            <!-- Allocation -->
            <!--
            <small class="label">Allocation</small>
             <v-select
              name="allocations"
             
              v-model="form.allocation"
              :options=allocations
              :reduce="option => option.value"
              placeholder="Select allocation"
            />
            </div> -->
            <!-- Frequency -->
            <!-- <div class="vx-col md:w-1/3 md:mb-0">
                <small class="label">Frequency</small>
                <v-select
                name="frequencies"
                v-model="form.frequency"

                :options="frequencies"
                :reduce="option => option.value"
                class="w-full"
                >
                </v-select>
            </div>
            </div> -->
            <!-- Description -->
             
            <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-3/3  md:mb-0">
                <small class="label">Description</small>
                <vs-textarea v-model="form.description" :rows="5"></vs-textarea>  
            </div>
            </div>
           
            <!-- Signoff Required -->
            <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-1/3 md:mb-0">
                <vs-checkbox v-model="form.signoff_required">
                Signoff Required
                </vs-checkbox>
            </div>
            </div>
            <TaskFields :id="id"/>
        
          

          <div class="flex flex-wrap items-center justify-end mt-8">
            <vx-tooltip v-if="form.status != 'In Active'" text="Set to Inactive" position="top">
            <div style="cursor: pointer" @click="deleteTemplate(form.id)" class="prepend-text btn-addon">
              <vs-button class="ml-3"  
              color="danger" type="border" icon-pack="feather" icon="icon-circle">Deactivate</vs-button>
            </div>
            </vx-tooltip>
            <vx-tooltip v-if="form.status == 'In Active'" text="Set to Active" position="top">
            <div style="cursor: pointer" @click="setDraftTemplate(form.id)" class="prepend-text btn-addon">
              <vs-button class="ml-3"  
              color="primary" type="border" icon-pack="feather" icon="icon-check">Activate</vs-button>
            </div>
            </vx-tooltip>
              <vx-tooltip v-if="form.status == 'Draft'" text="Publish Template" position="top">
            <div style="cursor: pointer" @click="publishTemplate(form.id)" class="prepend-text btn-addon">
              <vs-button class="ml-3"  
              color="primary" type="border" icon-pack="feather" icon="icon-check">Publish</vs-button>
            </div>
            </vx-tooltip>
            <vs-button  button="submit" class="ml-3">Save Changes</vs-button>
          </div>
        </form>
        <div class="flex">
        
        </div>
        </ValidationObserver>


 
      </vx-card>
         </div>
  </div>
</template>

<script>
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";
  import TaskFields from './taskFields.vue';
  import ScheduledTasksRepository from "@/repository/ScheduledTasksRepository";

  export default {
    name: "template-view",
    components: {
      'v-select': vSelect,
      TaskFields
    },
    data: function() {
      return {
        id: '',
        form: {
            name: '',
            description: '',
            frequency: '',
            allocation: '',
            signoff_required: true,
        },
        allocations: [],
        frequencies: [],
            dataLoaded: false,
        }
    },
    mixins : [ SuccessMessage, ErrorMessages],
    async mounted() {
        this.id = this.$route.params.id
        await this.getAllocations();
        await this.getFrequencies();
        await this.getTemplateDetails()
    //   await this.getSupplierInvoiceDocuments()
    },
    methods: {
        async getAllocations() {
        try {
          const { data } = await ScheduledTasksRepository.allocations();
          // create a new array so Vue detects the change
          this.allocations =data.data.sort((a, b) => a.label.localeCompare(b.label));
        } catch (err) {
          console.error("Failed to load allocations:", err);
        }
        },

      async getFrequencies() {
        try {
          const { data } = await ScheduledTasksRepository.frequencies();
          this.frequencies = data.data.sort((a, b) => a.label.localeCompare(b.label));
        } catch (err) {
          console.error("Failed to load frequencies:", err);
        }
      },
      async onClickCreateTemplate() {
        const vue = this;
        await this.$vs.loading({
          container: '#template-view',
          scale: 0.45
        })
        try {
          await ScheduledTasksRepository.updateTemplate(this.id, this.form);
          this.showSuccessMessage('Template updated successfully');
          this.$router.push({path: `/pages/settings?tab=staff+scheduled_task_templates`})
        } catch (e) {
          this.$vs.loading.close('#template-view > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#template-view > .con-vs-loading')
      },
      async deleteTemplate(id){
      try {
          const response = await ScheduledTasksRepository.deleteTemplate(id);
          this.refreshData();
          } catch (error) {
            console.error("Error making template inactive:", error);
          }
      },
      async setDraftTemplate(id){
      try {
          const response = await ScheduledTasksRepository.setDraftTemplate(id);
          this.refreshData()
          } catch (error) {
         
            console.error("Error making template inactive:", error);
          }
        },
      async publishTemplate(id){
        try {
            const response = await ScheduledTasksRepository.publishTemplate(id);
            this.refreshData()
            } catch (error) {
              console.error("Error publishing template:", error);
            }
      },
      onClickBack() {
        this.$router.push({path: `/pages/settings?tab=staff+scheduled_task_templates`})
      },
      async refreshData () {
         const {data} = await ScheduledTasksRepository.getTemplateDetails(this.id)
         this.form.status = data.data.status
      },
      async getTemplateDetails() {
        await this.$vs.loading({
          container: '#template-view',
          scale: 0.45
        })
        try {
          const {data} = await ScheduledTasksRepository.getTemplateDetails(this.id)
          this.form = data.data
        } catch (e) {
        }
        this.$vs.loading.close('#template-view > .con-vs-loading')
        this.dataLoaded= true
      },
    }
  }
</script>
